export default {
  'Operation administrator': 'Operation administrator',
  'Rule name': 'Rule name',
  controller: 'Controller',
  'data sheet': 'Data table',
  'Modify line': 'Modify row',
  Modification: 'Modify item',
  'Before modification': 'Before modification',
  'After modification': 'After modification',
  'Modification time': 'Modify time',
  'Are you sure you want to rollback the record?':
    'Are you sure to rollback the record?',
  'Rollback the selected record to the original data table':
    'Rollback the selected record to the original data table.',
  'Operator IP': 'Operator IP',
  'Data table primary key': 'Data table primary key',
  'Modified item': 'Modified item',
  'Modification comparison': 'Modify the comparison',
  RollBACK: 'Rollback'
}
